module.exports = __webpack_public_path__ + "static/media/top14FeaturesBanner_Tablet_738x57px_@1x.935f792e.jpg";